import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  button: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 56px;
    box-sizing: border-box;
    margin-top: ${theme.spacing(2)}px;
    padding: ${theme.spacing(1.5, 2)};
    cursor: pointer;
    border-radius: ${theme.spacing(2)}px;
    background-color: var(--colorScheme-bgMinor, #f5f4f2);

    :global(html[data-theme='dark']) & {
      background-color: var(--colorScheme-bgMinor, #302f2d);
    }
  `,
  placeholder: css`
    color: var(--colorScheme-textMinor, #9e9b98);

    :global(html[data-theme='dark']) & {
      color: var(--colorScheme-textMinor, rgba(224, 222, 218, 0.5));
    }
  `,
  placeholderTop: css`
    font-size: 13px;
  `,
  text: css`
    color: var(--colorScheme-text, #21201f);

    :global(html[data-theme='dark']) & {
      color: var(--colorScheme-text, #e0deda);
    }
  `,
  fixedWidth: css`
    width: 360px;
  `,
}
